import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from './queryKeys';

const getAcceptanceStages = async () => {
  return await request.get(
    `/FlatsGrid/acceptance_results`,
    {},
    'При загрузке возможных состояний приемки квартиры произошла ошибка',
    []
  );
};

const useAcceptanceStages = (options) =>
  useQuery(getQueryKeys.acceptanceStages(), getAcceptanceStages, options);

export default useAcceptanceStages;
